<template>
  <div v-if="selectedAd?.data?.entityType === 'Taia'" 
    class="relative rounded-md bg-cover bg-center bg-no-repeat text-white" 
    :style="{ backgroundImage: `url('${selectedAd.data.backgroundImage}')`, cursor:'pointer' }"
    role="button" 
    tabindex="0"  
    @click="initializeIframePopup" 
    @keydown.enter.space="initializeIframePopup" 
    aria-labelledby="taiaTitle" aria-describedby="taiaDescription taiaAction"
  >
    <div class="flex p-3 pb-16 md:pb-20 lg:pb-3 after:block after:pb-[100%] after:content-[''] after:h-auto">
      <div class="flex flex-col lg:justify-between">
        <NuxtImg class="h-18 w-18" :src="TaiaIcon" alt="Taia icon" />
          <p id="taiaTitle" class="mb-0 text-[1rem] sm:text-[1.35rem] font-semibold">
            {{ selectedAd.data.title }}
          </p>
          <p id="taiaDescription" class="mt-0 text-[0.93rem] sm:text-[1.15rem]">
            {{ selectedAd.data.description }}
          </p>
          <Button
            id="taiaAction" variant="secondary" theme="LIGHT" size="sm"
            class="hidden lg:flex cursor-pointer w-full rounded bg-white font-semibold text-black hover:text-gold-100 
            items-center justify-center text-center focus:outline-none focus:ring-2 focus:ring-gold-200"
            @click.stop.prevent="initializeIframePopup"
          >
            {{ selectedAd.data.actionButtonLabel }}
          </Button>
      </div>
    </div>
    <div class="absolute bottom-[3%] left-3 right-3 lg:hidden">
      <Button
        id="taiaAction" variant="secondary" theme="LIGHT" size="sm"
        class="cursor-pointer w-full rounded bg-white font-semibold text-black hover:text-gold-100 
        flex items-center justify-center text-center focus:outline-none focus:ring-2 focus:ring-gold-200"
        @click.stop.prevent="initializeIframePopup"
      >
        {{ selectedAd.data.actionButtonLabel }}
      </Button>
    </div>
  </div>
  <div v-else-if="selectedAd?.data?.entityType === 'Quiz'">
    <MarketingCard
      :title="selectedAd.data.title"
      :description="selectedAd.data.description"
      :actionButtonUrl="selectedAd.data.actionButtonUrl"
      :actionButtonLabel="selectedAd.data.actionButtonLabel"
      :backgroundImage="selectedAd.data.backgroundImage ?? undefined"
      icon="clipboard"
  />
  </div>
</template>

<script setup lang="ts">
import { useIframeStore } from '~/stores/chatAIStore'
import { storeToRefs } from "pinia";
import Button from "../../atom/button.vue";
import MarketingCard  from '../../organism/product/marketingCard.vue'
import TaiaIcon from '~/assets/tgpt/images/taia-icon-plain.svg'
import eventBusGtm from "@/composables/eventBusGtm";
import { useUserStore } from "@/stores/userStore";

const props = defineProps<{ selectedAd: any }>()
const iframeStore = useIframeStore()
const userStore = useUserStore();
const { isDynamicYieldVariationData } = storeToRefs(iframeStore);
const initializeIframePopup = () => {

  iframeStore.sendMessageToChatbot('queryChat', {
    currentMinimise: false,
  })
  
  const screenName = document.title;
  const customerId = userStore.data?.customerId ?? null;
  eventBusGtm.emit("trackEvent", {
    event: "Taia",
    button_name: "plp_card",
    screen_name: screenName,
    Customer_id: customerId,
    message_id: null,
    Selected_thread_id: null,
    target: null,
    productName: null,
    productSku: null,
    productPrice: null,
    skuid: null,
    sub_screen: null,
    article: null,
    Writing_style_preference: null,
    Content_preference: null,
    ResponseDetail_preference: null,
    Taia_campaign: null,
    search_term: null,
    variationName: isDynamicYieldVariationData.value?.name ?? null,
    experienceName: isDynamicYieldVariationData.value?.experienceName ?? null,
  });
}
</script>